
import DefaultButtons from '../forms/DefaultButtons.vue';
import FormAlerts from '../alerts/FormAlerts.vue';
import { FormProcessor } from '../../api/forms/processor';
import {
  Image,
  DefaultImage,
} from '../../api/images/image';
import { ImageShow } from '../../api/images/show';
import Vue from 'vue';

Vue.component('default-buttons', DefaultButtons);
Vue.component('form-alerts', FormAlerts);

export default Vue.component('image-show', {
  props: ['courseId'],
  data() {
    return {
      id: -1 as number,
      isNew: false,
      imageData: DefaultImage() as Image,
      processor: new FormProcessor(),
      imageUrl: ''
    };
  },
  methods: {
    handleCourseUpdate(courseId: number) {
      this.imageData.course_id = courseId;
      this.processor.setModified();
    },
    loadForm() {
      if (this.id <= 0) {
        return;
      }

      ImageShow.getData(this.id)
        .then((response) => {
          this.imageData = ImageShow.parseResponse(response);
          this.imageUrl = response.data.image_url || '';
        })
    },
    deleteForm() {
      if (this.processor === null || !this.processor.shouldDelete()) {
        return;
      }
      this.processor.deleteData(ImageShow, this.id);
    },
    deleteCallback() {
      this.$router.replace({ name: 'manage-images' });
    },
    handleFileUpload(file: File) {
      this.imageData.file = file;
      this.processor.setModified();
    },
    saveForm() {
      this.imageData.id = this.id;
      if (this.processor === null || !this.processor.shouldSave()) {
        return;
      }

      const formData = new FormData();
      formData.append('image[course_id]', this.imageData.course_id.toString());

      if (this.imageData.file) {
        formData.append('image[file]', this.imageData.file);
      }

      this.processor.saveData(
        ImageShow,
        formData,
        this.$refs.submitForm,
      );
    },
    undoForm() {
      if (this.processor === null || !this.processor.undoForm()) {
        return;
      }
      this.loadForm();
    },
    handleNew() {
      this.id = -1;
      this.isNew = true;
      if (this.$route.params.course_id) {
        this.imageData.course_id = Number(this.$route.params.course_id);
      }
      this.processor.setParams(
        this.id,
        this.imageData,
        DefaultImage(),
        this.updateCallback,
        this.saveCallback,
        this.deleteCallback,
      );
      this.processor.readOnly = false;
    },
    resetForm() {
      const id = this.$route.params.id;
      if (!id || id === 'new') {
        this.handleNew();
        return;
      }
      this.id = Number(id);
      if (this.id <= 0) {
        return;
      }
      this.processor.setParams(
        this.id,
        this.imageData,
        DefaultImage(),
        this.updateCallback,
        this.saveCallback,
        this.deleteCallback,
      );
      this.loadForm();
    },
    saveCallback(data: any) {
      // Reload the form on save so the serializers can
      // format any $/% data properly.
      if (this.isNew && data.id) {
        this.id = data.id;
        this.imageData.id = data.id;
        this.isNew = false;
      }
      this.loadForm();
    },
    updateCallback(formData: Image) {
      this.imageData = formData;
      this.imageUrl = formData.url || '';
    },
  },
  mounted() {
    if (this.courseId) {
      this.id = this.courseId;
    }
    this.resetForm();
  }
});
